module.exports = {
    comunas: ["QUILLOTA", "NOGALES", "HIJUELAS",
        "LA CALERA", "LA CRUZ", "OLMUE",
        "SAN FELIPE", "PANQUEHUE", "PUTAENDO",
        "SANTA MARIA", "LLAY LLAY", "CALLE LARGA",
        "SAN ESTEBAN", "RINCONADA", "RANCAGUA",
        "GRANEROS", "MOSTAZAL", "DONIHUE", "COLTAUCO",
        "PEUMO", "LAS CABRAS", "SAN VICENTE",
        "PICHIDEGUA", "REQUINOA", "OLIVAR",
        "MALLOA", "COINCO", "SAN FERNANDO",
        "CHIMBARONGO", "NANCAGUA", "PLACILLA",
        "SANTA CRUZ", "PALMILLA", "PERALILLO",
        "CHEPICA", "PICHILEMU", "NAVIDAD",
        "LITUECHE", "LA ESTRELLA", "PAREDONES",
        "CURICO", "TENO", "ROMERAL",
        "LICANTEN", "VICHUQUEN", "HUALANE",
        "MOLINA", "TALCA", "SAN CLEMENTE",
        "PELARCO", "RIO CLARO", "PENCAHUE",
        "CUREPTO", "CONSTITUCION", "EMPEDRADO",
        "SAN RAFAEL", "YERBAS BUENAS", "COLBUN",
        "LONGAVI", "RETIRO", "VILLA ALEGRE",
        "SAN JAVIER", "CAUQUENES", "CHANCO",
        "CHILLAN", "PINTO", "COIHUECO",
        "NINHUE", "PORTEZUELO", "COBQUECURA",
        "TREGUACO", "NIQUEN", "SAN FABIAN",
        "SAN NICOLAS", "BULNES", "QUILLON",
        "YUNGAY", "EL CARMEN", "RANQUIL",
        "CHILLAN VIEJO", "CONCEPCION", "PENCO",
        "HUALQUI", "TALCAHUANO", "CORONEL",
        "SANTA JUANA", "ARAUCO", "CURANILAHUE",
        "LEBU", "CANETE", "CONTULMO",
        "TIRUA", "LAJA", "QUILLECO",
        "NACIMIENTO", "MULCHEN", "YUMBEL",
        "SAN ROSENDO", "TUCAPEL", "ANTUCO",
        "LOS SAUCES", "COLLIPULLI", "ERCILLA",
        "TRAIGUEN", "CURACAUTIN", "LONQUIMAY",
        "VILCUN", "FREIRE", "PERQUENCO",
        "GALVARINO", "CARAHUE", "PITRUFQUEN",
        "GORBEA", "LONCOCHE", "VILLARRICA",
        "PUCON", "TEODORO SCHMIDT", "PADRE LAS CASAS",
        "MARIQUINA", "LANCO", "CORRAL",
        "MAFIL", "PANGUIPULLI", "PAILLACO",
        "RIO BUENO", "OSORNO", "PUERTO OCTAY",
        "PUYEHUE", "RIO NEGRO", "PUERTO MONTT",
        "COCHAMO", "FRESIA", "FRUTILLAR",
        "LLANQUIHUE", "MAULLIN", "CASTRO",
        "CHONCHI", "QUEILEN", "PUQUELDON",
        "QUEMCHI", "CURACO DE VELEZ", "QUINCHAO",
        "CHAITEN", "HUALAIHUE", "FUTALEUFU",
        "PALENA", "AYSEN", "CISNES",
        "CHILE CHICO", "RIO IBANEZ", "COCHRANE",
        "OHIGGINS", "COYHAIQUE", "LAGO VERDE",
        "PUERTO NATALES", "TORRES DEL PAINE", "SAN GREGORIO",
        "PUNTA ARENAS", "LAGUNA BLANCA", "PORVENIR",
        "TIMAUKEL", "CABO DE HORNOS", "ANTARTICA",
        "SANTIAGO", "PROVIDENCIA", "SAN MIGUEL",
        "QUINTA NORMAL", "LAS CONDES", "LA CISTERNA",
        "PUDAHUEL", "RENCA", "QUILICURA",
        "LA FLORIDA", "LA GRANJA", "LA REINA",
        "MACUL", "SAN RAMON", "LA PINTANA",
        "LO PRADO", "CERRO NAVIA", "HUECHURABA",
        "RECOLETA", "VITACURA", "LO BARNECHEA",
        "PEDRO AGUIRRE CERDA", "LO ESPEJO", "EL BOSQUE",
        "CERRILLOS", "INDEPENDENCIA", "LAMPA",
        "TILTIL", "PUENTE ALTO", "PIRQUE",
        "SAN BERNARDO", "CALERA DE TANGO", "BUIN",
        "PAINE", "TALAGANTE", "EL MONTE",
        "PENAFLOR", "PADRE HURTADO", "MELIPILLA",
        "MARIA PINTO", "SAN PEDRO", "ALHUE", "ARICA",
        "CAMARONES", "IQUIQUE", "PICA",
        "HUARA", "CAMINA", "COLCHANE",
        "PUTRE", "GENERAL LAGOS", "MARIA ELENA",
        "ANTOFAGASTA", "TALTAL", "SIERRA GORDA",
        "CALAMA", "OLLAGUE", "SAN PEDRO DE ATACAMA",
        "DIEGO DE ALMAGRO", "COPIAPO", "CALDERA",
        "TIERRA AMARILLA", "FREIRINA", "HUASCO",
        "ALTO DEL CARMEN", "LA HIGUERA", "COQUIMBO",
        "ANDACOLLO", "VICUNA", "MONTE PATRIA",
        "PUNITAQUI", "COMBARBALA", "ILLAPEL",
        "LOS VILOS", "ISLA DE PASCUA", "LA LIGUA",
        "CABILDO", "VALPARAISO", "VINA DEL MAR",
        "VILLA ALEMANA", "QUINTERO", "JUAN FERNANDEZ",
        "CONCON", "SAN ANTONIO", "EL TABO",
        "EL QUISCO", "ALTO HOSPICIO", "HUALPEN",
        "FLORIDA", "CHIGUAYANTE", "LOS ALAMOS",
        "LOS ANGELES", "NEGRETE", "CABRERO",
        "RENAICO", "LUMACO", "TEMUCO",
        "LAUTARO", "NUEVA IMPERIAL", "TOLTEN",
        "VALDIVIA", "FUTRONO", "LA UNION",
        "SAN PABLO", "PURRANQUE", "LOS MUERMOS",
        "QUELLON", "DALCAHUE", "OVALLE",
        "RIO HURTADO", "CANELA", "PETORCA",
        "PAPUDO", "QUILPUE", "PUCHUNCAVI",
        "SANTO DOMINGO", "ALGARROBO", "CHOLCHOL",
        "LIMACHE", "CATEMU", "LOS ANDES",
        "MACHALI", "CODEGUA", "RENGO",
        "QUINTA DE TILCOCO", "LOLOL", "PUMANQUE",
        "MARCHIGUE", "RAUCO", "SAGRADA FAMILIA",
        "MAULE", "LINARES", "PARRAL",
        "PELLUHUE", "QUIRIHUE", "SAN CARLOS",
        "SAN IGNACIO", "COELEMU", "TOME",
        "SAN PEDRO DE LA PAZ", "SANTA BARBARA", "QUILACO",
        "PUREN", "VICTORIA", "CUNCO",
        "PUERTO SAAVEDRA", "CURARREHUE", "LOS LAGOS",
        "LAGO RANCO", "SAN JUAN DE LA COSTA", "CALBUCO",
        "ANCUD", "GUAITECAS", "TORTEL",
        "RIO VERDE", "PRIMAVERA", "NUNOA",
        "MAIPU", "CONCHALI", "PENALOLEN",
        "ESTACION CENTRAL", "SAN JOAQUIN", "COLINA",
        "SAN JOSE DE MAIPO", "ISLA DE MAIPO", "CURACAVI",
        "POZO ALMONTE", "TOCOPILLA", "MEJILLONES",
        "CHANARAL", "VALLENAR", "LA SERENA",
        "PAIHUANO", "SALAMANCA", "ZAPALLAR",
        "CASABLANCA", "CARTAGENA", "ALTO BIOBIO",
        "LOTA", "ANGOL", "MELIPEUCO",
        "PUERTO VARAS", "PEMUCO"]
}